import type { SaldoDaConta, SituacaoDoSaldo } from "@base/contracts";

/** O que pede a Monte agir agora. Conta desativada ou inativa nunca entra. */
const EM_ALERTA: ReadonlySet<SituacaoDoSaldo> = new Set(["pagamento-pendente", "abaixo-do-minimo"]);

/** Contas para o alerta do login, na ordem de urgencia que a API ja manda. */
export function contasEmAlerta(contas: readonly SaldoDaConta[]): readonly SaldoDaConta[] {
  return contas.filter((conta) => conta.monitorada && EM_ALERTA.has(conta.situacao));
}
